export default {
    nav: {
      about: "About",
      services: "Services",
      momo: "MOMO",
      team: "Team",
      contact: "Contact",
      cta: "Start MOMO",
    },
    hero: {
      badge: "AI-Driven Technology Company",
      line1: "Through AI,",
      highlight: "People to People",
      line2: "Connecting Technology",
      sub1: "IKOB breaks down language barriers with AI,",
      sub2: "building a new platform where the world meets.",
      cta: "Learn About IKOB",
    },
    about: {
      label: "About IKOB",
      title1: "The Intelligence",
      title2: "Bridging Humans & Technology",
      p1_pre: "IKOB is a company that creates ",
      p1_bold: "technology to connect people through AI-driven services",
      p1_suf: ".",
      p2_pre: "Our AI core goes beyond simple automation — it designs trust between people. Centered around our social exchange platform ",
      p2_suf: ", we leverage lifestyle and compatibility algorithms to build a world where people naturally connect through safe and comfortable encounters.",
      p3: "The MOMO platform will expand into services that fulfill users' emotional needs, becoming a close companion for modern people seeking meaningful connection.",
      val_i_word: "Inspire",
      val_i_desc: "The Inspirer. Discovering new possibilities and creating value through cultural exchange.",
      val_k_word: "Know",
      val_k_desc: "The Knowledge Designer. Building sophisticated AI-driven technology architectures.",
      val_o_word: "Optimize",
      val_o_desc: "AI Core · Central Intelligence. The heart of intelligence connecting humans and technology.",
      val_b_word: "Build",
      val_b_desc: "The Builder. Turning ideas into real products and services that shape the world.",
      stat1_num: "70%",
      stat1_label: "Foreign tourists\nwish to meet locals",
      stat2_num: "86%",
      stat2_label: "Struggle to connect\ndue to language barriers",
      stat3_num: "100ms",
      stat3_label: "Real-time nearby\nmatching speed",
      stat4_num: "3-Step",
      stat4_label: "Multi-step ID verification\nsafety system",
    },
    services: {
      label: "Core Technology",
      title: "Core Technology",
      desc: "Safe, real-time connection experiences powered by IKOB's AI technology",
      tech1_tag: "Location",
      tech1_title: "PostGIS Real-time Search Engine",
      tech1_desc: "Using location-based database technology, we find nearby users and gatherings within 100ms, providing accurate distance calculations and fast response times.",
      tech2_tag: "AI · NLP",
      tech2_title: "AI Real-time Translation Agent",
      tech2_desc: "GPT-4-based real-time voice translation enables natural conversation without language barriers. Supports Korean, English, Japanese, Chinese, and more.",
      tech3_tag: "Safety",
      tech3_title: "AI Safety Agent",
      tech3_desc: "Real-time conversation monitoring and automatic threat detection ensure a safe exchange environment, with 3-step identity verification via passport OCR.",
      tech4_tag: "Trust Score",
      tech4_title: "Behavior-based Trust Scoring",
      tech4_desc: "We analyze users' actual behavior patterns to calculate trust scores, creating a safe and trustworthy community environment for everyone.",
    },
    momo: {
      label: "Service Platform",
      title1: "K-Culture Social Exchange",
      title2: "Platform",
      desc: "A new social experience connecting\nforeigners and Koreans in real time",
      feat1_title: "MOMO NOW",
      feat1_desc: "Map-based real-time local feed. Instantly discover gatherings and people around you right now.",
      feat2_title: "Spontaneous Matching System",
      feat2_desc: "No reservations — meet 'right now, right here'. Non-Dating design for pure cultural exchange.",
      feat3_title: "3-Step Safety Verification",
      feat3_desc: "Multi-step verification including passport OCR ensures only verified users can connect.",
      feat4_title: "Local Partnership",
      feat4_desc: "Collaborating with local businesses to deliver authentic Korean experiences while boosting the local economy.",
      install_cta: "Install MOMO",
    },
    social: {
      label: "Social Impact",
      title: "Social Value",
      desc: "A better world built by IKOB",
      card1_title: "Global Cultural Exchange",
      card1_desc: "We create an environment where foreigners and Koreans naturally meet\nand authentically experience K-culture beyond language barriers.",
      card2_title: "Local Shared Economy",
      card2_desc: "We connect underserved local businesses with foreign tourists\nto drive tourism revitalization and a virtuous cycle in the local economy.",
      card3_title: "Safe Exchange Environment",
      card3_desc: "We build a fair platform where all users\ncan trust and participate, supported by AI-based safety agents and multi-step verification systems.",
    },
    team: {
      label: "Our Team",
      title1: "The People",
      title2: "Leading IKOB",
      desc: "Building a shared vision with each individual's unique expertise",
      m1_name: "Junho Oh",
      m1_title: "CEO",
      m1_subtitle: "Chief Executive Officer",
      m1_edu: "Sogang University, MSc in Data Science & AI Engineering",
      m1_bio: "Junho Oh founded IKOB with deep expertise in AI and data science. His mission is to create new value at the intersection of humans and technology, building a world where people everywhere can connect more easily and safely through MOMO.",
      m2_name: "Heejun Kim",
      m2_title: "CTO",
      m2_subtitle: "Chief Technology Officer",
      m2_edu: "Sogang University, MSc in Data Science & AI Engineering",
      m2_bio: "Heejun Kim builds the technological foundation of MOMO through AI architecture design and full-stack development. He oversees the PostGIS-based real-time location engine, AI translation agent, and safety system development.",
      m3_name: "Mijin Im",
      m3_title: "CMO",
      m3_subtitle: "Chief Marketing Officer",
      m3_edu: "Chung-Ang University, BA in English Language & Literature",
      m3_bio: "Mijin Im leads MOMO's market expansion with brand strategy and digital marketing expertise. She oversees content marketing leveraging K-culture trends and global user growth strategies, conveying IKOB's brand values to the world.",
      m4_name: "Jungyeol Bhang",
      m4_title: "CLO",
      m4_subtitle: "Chief Legal Officer",
      m4_edu: "Seoul National University, Law",
      m4_bio: "Jungyeol Bhang oversees IKOB's legal affairs as a partner at a major law firm. He handles personal data protection, AI ethics compliance, and contract & investment legal advisory.",
    },
    contact: {
      label: "Contact Us",
      title1: "Explore New",
      title2: "Possibilities",
      title3: "with IKOB",
      desc: "Feel free to reach out for investment inquiries,\npartnerships, or service-related questions.",
      website_label: "Website",
      email_info_label: "Email",
      phone_label: "Phone",
      address_label: "Address",
      momo_label: "MOMO Service",
      address_val: "HQ: 2F, 244-ho, 2 Yangdong-ro 25beon-gil, Seo-gu, Gwangju\nAI Lab: 2F, 498A-ho, 47 Gangnam-daero 112-gil, Gangnam-gu, Seoul",
      form_title: "Send an Inquiry",
      name_label: "Name *",
      name_placeholder: "Enter your name",
      email_label: "Email *",
      email_placeholder: "Enter your email address",
      type_label: "Inquiry Type",
      type1: "Investment Inquiry",
      type2: "Partnership",
      type3: "Service Inquiry",
      type4: "Recruitment",
      type5: "Other",
      msg_label: "Message *",
      msg_placeholder: "Please enter your inquiry",
      error: "An error occurred while sending. Please try again.",
      submit: "Send Inquiry",
      sending: "Sending...",
      success_title: "Inquiry Submitted!",
      success_desc: "We will get back to you as soon as possible.",
      retry: "Send Another Inquiry",
    },
    footer: {
      tagline: "Technology that connects people through AI.",
      momo_desc: "Building MOMO, a K-culture based social exchange platform.",
      tagline2: "Inspire · Know · Optimize · Build",
      company_name: "IKOB Co., Ltd.",
      ceo_prefix: "CEO:",
      ceo_name: "Junho Oh",
      address: "HQ: 2F, 244-ho, 2 Yangdong-ro 25beon-gil, Seo-gu, Gwangju | AI Lab: 2F, 498A-ho, 47 Gangnam-daero 112-gil, Gangnam-gu, Seoul",
      nav_company: "Company",
      nav_about: "About",
      nav_team: "Team",
      nav_tech: "Core Technology",
      nav_recruit: "Careers",
      nav_services: "Services",
      nav_momo: "About MOMO",
      nav_social: "Social Value",
      nav_invest: "Investment",
      nav_partner: "Partnership",
      copyright: "© 2026 IKOB Co., Ltd. All rights reserved.",
      sub_tagline: "Technology that connects people through AI",
    },
  };